<template>
    <v-container fluid>
        <v-card tile :loading="loading">
            <div class="card-title">{{$t('Municipalities')}} </div>

            <!-- Municipalities Tab Content -->
            <v-card-text>
                <v-row justify="space-between">
                    <v-col cols="4">
                        <v-row>
                            <v-col cols="6">
                                <v-btn class="mx-2 my-2" fab dark small color="primary" @click="addNewStructure">
                                    <v-icon>mdi-folder-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-sheet dense class="pa-4 mt-4" color="secondary">
                            <v-text-field v-model="search" dense :label="$t('Search')" dark flat solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline" @input="handleSearch" />
                        </v-sheet>
                        <v-treeview ref="tree" :items="result" :search="search" :filter="filter" activatable item-key="id" :open.sync="open">
                            <template v-slot:prepend="{ open }">
                                <v-icon>
                                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                            </template>
                            <template v-slot:label="{ item }">
                                <template>
                                    <a class="d-block pa-2" @click="viewStructureDetails(item)">
                                        {{ item.name }}
                                    </a>
                                </template>
                            </template>
                        </v-treeview>
                    </v-col>
                    <v-divider vertical />

                    <v-col>
                        <v-scroll-y-transition mode="out-in">
                            <div v-if="show">
                                <v-tabs grow background-color="#dedede">
                                    <v-tab>
                                        <v-icon>
                                            mdi-sitemap
                                        </v-icon>
                                        <h3 class="ms-2">{{ $t('Users') }}</h3>
                                    </v-tab>
                                    <v-tab>
                                        <v-icon>
                                            mdi-sitemap
                                        </v-icon>
                                        <h3 class="ms-2">{{ $t('Design') }}</h3>
                                    </v-tab>
                                    <v-tab-item>
                                        <!-- Design Tab Content -->
                                        <v-card-text>
                                            <v-row justify="space-between">
                                                <v-col>
                                                    <v-scroll-y-transition mode="out-in">
                                                        <div v-if="show">
                                                            <v-row>
                                                                <v-col cols="12" md="9">
                                                                    <h3 class="primary--text">{{ selectedStructureTitle }}</h3>
                                                                </v-col>
                                                                <v-col cols="12" md="3" class="text-end">
                                                                    <!-- to do soft delete -->
                                                                    <v-btn small color="error" tile style="display:none;">
                                                                        {{ $t('Delete') }}
                                                                        <v-icon small class="ms-2">mdi-trash-can-outline</v-icon>
                                                                    </v-btn>
                                                                    <v-btn small color="primary" class="ms-3 white--text" tile @click="editMunicipality">
                                                                        {{ $t('Edit') }}
                                                                        <v-icon small class="ms-2">mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                            <v-card tile class="mt-6">
                                                                <div class="card-title">{{ $t('UsersInStructure') }}</div>
                                                                <v-data-table dense :headers="headers" :items="users" :items-per-page="10">
                                                                    <template v-slot:top>
                                                                        <v-btn small class="ma-4 white--text" tile color="secondary" @click="openUserAddDialog()">
                                                                            {{ $t('AddUser') }} <v-icon small class="ms-2">mdi-account</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <template v-slot:[`item.options`]="{ item }">
                                                                        <v-icon color="error" @click="removeUserFromMunicipality(item.id)">mdi-trash-can-outline</v-icon>
                                                                    </template>
                                                                </v-data-table>
                                                            </v-card>
                                                        </div>
                                                    </v-scroll-y-transition>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item>

                                        <v-card-text>
                                            <v-form ref="designForm" v-model="designValid" lazy-validation>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="12" md="9">
                                                            <h3 class="primary--text">{{ selectedStructureTitle }}</h3>
                                                        </v-col>
                                                        <v-col cols="12" md="3" class="text-end">
                                                            <v-btn color="primary"
                                                                   style="margin: 0px 10px;"
                                                                   class="white--text"
                                                                   tile
                                                                   small
                                                                   @click="saveDesignChanges">
                                                                {{ $t("Save") }}
                                                            </v-btn>
                                                            <v-btn color="error"
                                                                   class="white--text"
                                                                   tile
                                                                   small
                                                                   @click="resetDesignChanges">
                                                                {{ $t("Cancel") }}
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                    <template v-slot:actions>

                                                    </template>
                                                    <v-row class="mt-2 mb-2">
                                                        <v-col cols="12">
                                                            <h3 class="ms-2" style="padding: 10px 0px;">{{ $t('Header') }}</h3>
                                                            <quill-editor v-model="design.headerText"
                                                                          :label="$t('Header')"
                                                                          class="mb-3" />
                                                            <v-card class="mt-4 pa-3"
                                                                    v-if="design.headerText">
                                                                <div v-html="design.headerText"></div>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row class="mt-2 mb-2">
                                                        <v-col cols="12">
                                                            <h3 class="ms-2" style="padding: 10px 0px;">{{ $t('Footer') }}</h3>
                                                            <quill-editor v-model="design.footerText"
                                                                          :label="$t('Footer')"
                                                                          class="mb-3" />
                                                            <v-card class="mt-4 pa-3"
                                                                    v-if="design.footerText">
                                                                <div v-html="design.footerText"></div>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>

                                                    <v-row class="mt-2 mb-2">
                                                        <v-col cols="12">
                                                            <h3 class="ms-2" style="padding: 10px 0px;">{{ $t('Logo') }}</h3>
                                                            <v-file-input :rules="[fileRules]"
                                                                          dense
                                                                          :label="$t('LogoUpload')"
                                                                          accept="image/*"
                                                                          prepend-icon="mdi-image"
                                                                          @change="handleFileUpload" />
                                                            <v-img v-if="design.logoUrl"
                                                                   :src="design.logoUrl"
                                                                   class="mt-3"
                                                                   max-width="200px" />
                                                        </v-col>
                                                    </v-row>

                                                </v-container>
                                            </v-form>
                                        </v-card-text>
                                    </v-tab-item>
                                </v-tabs>
                            </div>
                        </v-scroll-y-transition>
                    </v-col>
                </v-row>
            </v-card-text>


            <!-- Other Dialogs and Forms -->
            <v-form ref="userInMunicipalityForm" v-model="valid" lazy-validation>
                <CommonDialog v-if="userAddDialog" v-model="userAddDialog" :fullscreen="false" width="700" :title="$t('AddUser')" show-action-toolbar>
                    <v-container>
                        <v-row class="mt-2 mb-2">
                            <v-col cols="12">
                                <UserAutocomplete v-model="selectedUserId" :rules="nameRules" required :label="$t('SelectUserSearch')" class="mt-4 mb-4" />
                            </v-col>
                        </v-row>
                    </v-container>
                    <template v-slot:actions>
                        <v-btn color="secondary" class="white--text" tile small @click="saveUserToMunicipality">
                            {{ $t("Add") }}
                        </v-btn>
                        <v-btn color="error" class="white--text" tile small @click="userAddDialog = false;">
                            {{ $t("Cancel") }}
                        </v-btn>
                    </template>
                </CommonDialog>
            </v-form>

            <v-form ref="MunicipalityForm" v-model="valid" lazy-validation>
                <CommonDialog v-if="municipalityAddDialog" v-model="municipalityAddDialog" :fullscreen="false" width="700" :title="$t('AddMunicipality')" show-action-toolbar>
                    <v-container>
                        <v-row class="mt-2 mb-2">
                            <v-col cols="12" md="6">
                                <v-text-field v-model="municipality.nameAr" dense :label="$t('NameAr')" :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="municipality.nameEn" dense :label="$t('NameEn')" :rules="nameRules" required />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="municipality.municipalityId" dense :label="$t('Code')" :rules="nameRules" required />
                            </v-col>
                        </v-row>
                    </v-container>
                    <template v-slot:actions>
                        <v-btn color="secondary" class="white--text" tile small @click="saveMunicipality">
                            {{ $t("Add") }}
                        </v-btn>
                        <v-btn color="error" class="white--text" tile small @click="municipalityAddDialog = false;">
                            {{ $t("Cancel") }}
                        </v-btn>
                    </template>
                </CommonDialog>
            </v-form>
        </v-card>
    </v-container></template>
<script>
    import CommonDialog from '@/components/controls/CommonDialog'
    import UserAutocomplete from '@/components/controls/UserSelect'
    import StructuresService from '@/services/StructuresService.js'
    import UsersService from '@/services/UsersService.js'
    import { quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.snow.css'

    export default {
        components: {
            UserAutocomplete, CommonDialog, quillEditor
        },

        data() {
            return {
                show: false,
                valid: true,
                designValid: true,
                userAddDialog: false,
                municipalityAddDialog: false,
                loading: true,
                structureDialog: false,
                userDialog: false,
                isEditMunicipality: false,
                isEditUser: false,
                selectedStructureTitle: '',
                result: [],
                users: [],
                open: [1, 2],
                municipality: {
                    id: null,
                    nameAr: '',
                    nameEn: '',
                    municipalityId: ''
                },
                design: {
                    headerText: '',
                    footerText: '',
                    logoUrl: ''
                },
                totalCount: 0,
                selectedMunicipalityId: null,
                selectedUserId: null,
                tab: null,
                search: null,
                selectedRoleId: null,
                options: {
                    page: 1, itemsPerPage: 10
                },
                headers: [
                    { text: this.$t('Id'), value: 'id' },
                    { text: this.$t('FullName'), value: 'fullname' },
                    { text: this.$t('Email'), value: 'email' },
                    { text: this.$t('Options'), value: 'options' },
                ],
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                fileRules: [
                    v => !v || ['image/jpeg', 'image/png', 'image/gif'].includes(v.type) || this.$t('InvalidFileType')
                ]
            }
        },

        computed: {
            filter() {
                return this.caseSensitive
                    ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                    : undefined
            },
        },

        watch: {

        },

        created() {
            this.listMunicipalities()
        },

        methods: {
            handleFileUpload(file) {
                if (file) {
                    const reader = new FileReader()
                    reader.onload = (e) => {
                        this.design.logoUrl = e.target.result
                    }
                    reader.readAsDataURL(file)
                } else {
                    this.design.logoUrl = ''
                }
            },
            handleSearch(input) {
                if (input) {
                    this.$refs.tree.updateAll(true)
                } else {
                    this.$refs.tree.updateAll(false)
                }
            },
            openUserAddDialog() {
                this.selectedUserId = null
                this.selectedRoleId = null
                this.userAddDialog = true
            },

            addNewStructure() {
                this.isEditMunicipality = false
                this.resetMunicipalityObj()
                this.municipalityAddDialog = true
            },
            resetMunicipalityObj() {
                this.municipality.id = null,
                    this.municipality.nameAr = '',
                    this.municipality.nameEn = '',
                    this.municipality.municipalityId = ''
            },
            editMunicipality() {
                this.isEditMunicipality = true
                this.municipalityAddDialog = true
                this.getMunicipalityInfo(this.selectedMunicipalityId)
            },
            getMunicipalityInfo(municipalityId) {
                StructuresService.getMunicipalityById(municipalityId).then((res) => {
                    if (res.success) {
                        this.municipality = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            updated(value) {
                if (value) {
                    this.listMunicipalities()
                }
            },

            userUpdated(value) {
                if (value) {
                    this.listAdminUsers()
                }
            },

            listMunicipalities() {
                StructuresService.listMunicipalities().then((res) => {
                    if (res.data) {
                        this.result = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            viewStructureDetails(item) {
                if (item.id) {
                    this.show = true
                    this.selectedMunicipalityId = item.id
                    this.selectedStructureTitle = item.name
                    this.listUsersInMunicipality(item.id)
                    this.GetDesignMunicipality(item)
                }
            },
            GetDesignMunicipality(item) {
                this.design.headerText = item.header
                this.design.footerText = item.footer
                this.design.logoUrl = item.logoUrl

            },
            listUsersInMunicipality(municipalityId) {
                StructuresService.listUsersInMunicipality(municipalityId).then((res) => {
                    if (res.data) {
                        this.users = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            saveUserToMunicipality() {
                if (this.$refs.userInMunicipalityForm.validate()) {
                    StructuresService.addUserToMunicipality(this.selectedMunicipalityId, this.selectedUserId).then((res) => {
                        if (res.success) {
                            this.userAddDialog = false
                            this.listUsersInMunicipality(this.selectedMunicipalityId)
                        }
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
            saveMunicipality() {
                if (this.$refs.MunicipalityForm.validate()) {
                    if (this.isEditMunicipality == true) {
                        this.EditMunicipality()
                    } else {
                        this.AddMunicipality()
                    }
                }
            },
            AddMunicipality() {
                StructuresService.addMunicipality(this.municipality).then((res) => {
                    if (res.success) {
                        this.municipalityAddDialog = false
                        this.listMunicipalities()
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            EditMunicipality() {
                StructuresService.updateMunicipality(this.selectedMunicipalityId, this.municipality).then((res) => {
                    if (res.success) {
                        this.municipalityAddDialog = false
                        this.listMunicipalities()
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            async removeUserFromMunicipality(userId) {
                if (await this.$root.$confirm(this.$t('Delete'), this.$t('ConfirmDelete'))) {
                    this.loading = true
                    StructuresService.removeUserFromMunicipality(this.selectedMunicipalityId, userId)
                        .then(() => {
                            this.listUsersInMunicipality(this.selectedMunicipalityId)
                        })
                        .catch(() => {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }).finally(() => this.loading = false)
                }
            },

            saveDesignChanges() {
                if (this.$refs.designForm.validate()) {

                    StructuresService.addMunicipalityDesign(this.selectedMunicipalityId, this.design).then((res) => {
                        if (res.success) {
                            this.listMunicipalities()

                        }
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            resetDesignChanges() {
            }
        },
    }
</script>

<style>
    .v-treeview-node__label {
        cursor: pointer !important
    }

    .w-500 {
        width: 500px !important
    }
</style>
